<template>
  <Loader v-if="loading" />
  <div class="flex justify-content-center align-items-center h-6rem">
    <h1>Annullamento Pratica</h1>
  </div>
  <!-- <div>
    <div class="center-content">
      <Card class="upload-card">
        <template #content>
          <h3 class="page-title">Annullamento Pratiche</h3>
          <div class="upload-content">
            <div class="upload-zone">
              <div class="button-wrapper">
                <span class="label">{{
                  fileToUpload.length == 0
                    ? "Seleziona File"
                    : fileToUpload.length + " files"
                }}</span>
                <input id="upload" type="file" ref="file" @change="handleFileUpload($event)"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" multiple />
              </div>
              <div v-show="validationErrors.files && submitted" class="p-error">
                Campo richiesto.
              </div>
              <div v-show="validationErrors.type && submitted" class="p-error">
                Formato non consentito
              </div>
              <div class="text-center">
                <small>Formati consentiti: {{ allowedType.join(", ") }}</small>
              </div>
            </div>
            <div v-if="fileToUpload.length > 0" class="file-preview-container">
              <h3>Anteprima File</h3>
              <ul class="file-preview-list">
                <li v-for="(file, index) in fileToUpload" :key="index" class="file-preview-item">
                  <i class="pi pi-file file-icon"></i>
                  <span class="file-name">{{ file.name }}</span>
                  <button @click="removeFile(index)" class="remove-button">
                    <i class="pi pi-times"></i>
                  </button>
                </li>
              </ul>
            </div>
            <div class="action-buttons">
              <Button @click="uploadFileAnnullamentoPraticaOnFtp" class="upload-button">
                <i class="pi pi-upload"></i>
                <span>Carica File</span>
              </Button>
            </div>
          </div>
        </template>
      </Card>
    </div>
  </div> -->
  <div class="center-content">
    <Card class="history-card">
      <template v-slot:header>
        <br>
        <h3 class="page-title">Storico File Caricati</h3>
      </template>
      <template v-slot:content>
        <div>
          <input type="text" v-model="searchQuery" placeholder="Cerca file..." class="file-search-input">
        </div>
        <table class="file-table">
          <thead>
            <tr>
              <th>File</th>
              <th>Data di caricamento</th>
              <th>Utente</th>
              <th>Scarica</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="file in uploadedFiles" :key="file.file_name">
              <td>{{ file.file_name }}</td>
              <td>{{ file.created_at }}</td>
              <td>
                <span class="email">{{ file.email }}</span>
              </td>
              <td>
                <button @click.stop.prevent="handleFileDownload(file.file_name)"
                  class="download-button">
                  <i class="pi pi-download"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="file-count-select-wrapper">
          <select id="fileCount" v-model="filesPerPage" class="file-count-select">
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </div>
      </template>
    </Card>
    <div class="center-content">
      <Card class="history-card">
        <template v-slot:header>
          <br>
          <h3 class="page-title">Storico Elaborazione File</h3>
        </template>
        <template v-slot:content>
          <table class="file-table">
            <thead>
              <tr>
                <th>Id</th>
                <th>operation</th>
                <th>created_at</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in logMessages" :key="item.id">
                <td>{{ item.id }}</td>
                <td>{{ item.operation }}</td>
                <td>{{ moment(item.created_at).format('DD-MM-YYYY') }}</td>
              </tr>
            </tbody>
          </table>
        </template>
      </Card>
    </div>
  </div>
</template>



<script>
import { ref, computed, getCurrentInstance, onMounted } from 'vue';
import { useStore } from 'vuex'
import Service from '@/services/ask-caricamento-file/caricamento-file'
import Loader from "@/components/Loader.vue"
import { useToast } from 'primevue/usetoast';
import moment from 'moment';




export default {
  components: {
    Loader,
  },


  setup() {
    const store = useStore()
    const toast = useToast();
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    const service = new Service(self.$eventBus)
    const fileToUpload = ref([])
    const currentUser = ref(store.state.auth.user)
    const allowedType = ['csv', 'xlsx'];
    const validationErrors = ref({})
    const submitted = ref(false)
    const loading = ref(false)
    const uploadedFiles = ref([])
    const currentPage = ref(1);
    const filesPerPage = ref(10);
    const searchQuery = ref('');
    const logMessages = ref([]);

    const filteredFiles = computed(() => {
      return uploadedFiles.value.filter(file => {
        return file.name.toLowerCase().includes(searchQuery.value.toLowerCase());
      });
    });

    const paginatedFiles = computed(() => {
      const startIndex = (currentPage.value - 1) * filesPerPage.value;
      const endIndex = startIndex + filesPerPage.value;
      return uploadedFiles.value.slice(startIndex, endIndex);
    });

    const handleFileDownload = async (filename) => {
      try {
        console.log(filename);
        const response = await service.downloadAnnullamenti(filename);

        const blob = new Blob([response.data], { type: "application/octet-stream" });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;

        link.setAttribute("download", filename);

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Errore durante il download:", error);

        let errorMessage = "Errore durante il download del file";
        if (error.response && error.response.status === 404) {
          errorMessage = "File non trovato";
        } else if (error.response && error.response.status === 500) {
          errorMessage = "Errore interno del server";
        }

        toast.add({
          severity: "error",
          summary: "Errore",
          detail: errorMessage,
          life: 3000,
        });
      }
    }

    const handleFileUpload = (evt) => {
      const files = evt.target.files;
      const validFiles = [];
      const maxSize = 500000 * 1024;

      if (files) {
        for (let i = 0; i < files.length; i++) {
          const file = files[i];
          const extension = file.name.split('.').pop().toLowerCase();

          // Verifica dimensione
          if (file.size > maxSize) {
            toast.add({
              severity: "error",
              summary: "Errore",
              detail: `Il file ${file.name} supera la dimensione massima consentita (500 MB)`,
              life: 3000,
            });
            continue;
          }

          // Verifica estensione
          if (!allowedType.includes(extension)) {
            toast.add({
              severity: "error",
              summary: "Errore",
              detail: `Il file ${file.name} ha un formato non consentito`,
              life: 3000,
            });
            continue;
          }

          validFiles.push(file);
        }
      }

      fileToUpload.value = validFiles;
      const label = document.querySelector(".label");
      label.textContent = validFiles.length === 0 ? "Seleziona File" : `${validFiles.length} files`;
    };
    const uploadFileAnnullamentoPraticaOnFtp = () => {
      submitted.value = true;
      if (validateForm()) {
        loading.value = true;

        service.uploadFileAnnullamentoPraticaOnFtp(fileToUpload.value)
          .then(response => {
            const uploaded = response.files;

            uploaded.forEach(file => {
              file.uploader = currentUser.value;
            });

            uploadedFiles.value = [...uploadedFiles.value, ...uploaded];

            const message = response.message || 'File Caricati con successo';
            toast.add({ severity: 'success', summary: 'Successo', detail: message, life: 5000 });

            fetchUploadedFiles();
          })
          .catch(error => {
            toast.add({ severity: 'success', summary: 'Successo', detail: 'File Caricati con successo' });
          })
          .finally(() => {
            loading.value = false;
          });
      }
    }

    const getLogsFileElaborazioneAskFileAnnullamentoPratiche = async () => {
      loading.value = true;

      service
        .getLogsFileElaborazioneAskFile('annullamento-pratiche')
        .then((res) => {
          logMessages.value = res.items
          console.log(logMessages.value);
        })
        .catch((err) => { })
        .finally(() => {
          loading.value = false;
        });
    };


    const fetchUploadedFiles = async () => {
      try {
        const filesResponse = await service.getAllUploadedFilesAnnullamentoPratica();
        const formattedFiles = filesResponse.map(file => {
          return {
            ...file,
            created_at: moment(file.created_at).format('YYYY-MM-DD HH:mm:ss')
          };
        });
        uploadedFiles.value = formattedFiles;
      } catch (error) {
        console.error("Errore durante il recupero dei file:", error);
        toast.add({ severity: 'error', summary: 'Errore', detail: 'Errore durante il recupero dei file' });
      }
    };



    fetchUploadedFiles();
    onMounted(fetchUploadedFiles);
    onMounted(getLogsFileElaborazioneAskFileAnnullamentoPratiche);

    const validateForm = () => {
      validationErrors.value = {};

      if (fileToUpload.value.length === 0) {
        validationErrors.value['files'] = true;
        toast.add({
          severity: "error",
          summary: "Errore",
          detail: "Seleziona almeno un file da caricare",
          life: 3000,
        });
        return false;
      }

      const hasInvalidExtensions = fileToUpload.value.some(file => {
        const extension = file.name.split('.').pop().toLowerCase();
        return !allowedType.includes(extension);
      });

      if (hasInvalidExtensions) {
        validationErrors.value['type'] = true;
        toast.add({
          severity: "error",
          summary: "Errore",
          detail: `Formati file consentiti: ${allowedType.join(", ")}`,
          life: 3000,
        });
        return false;
      }

      return true;
    };

    const removeFile = (index) => {
      const updatedFiles = [...fileToUpload.value];
      updatedFiles.splice(index, 1);
      fileToUpload.value = updatedFiles;

      // Aggiorna il testo del label
      const label = document.querySelector(".label");
      label.textContent =
        updatedFiles.length === 0
          ? "Seleziona File"
          : `${updatedFiles.length} files`;

      // Reset input se non ci sono più file
      if (updatedFiles.length === 0 && self.refs.file) {
        self.refs.file.value = '';
      }
    };
    return {
      store,
      validationErrors,
      submitted,
      service,
      fileToUpload,
      handleFileUpload,
      allowedType,
      uploadFileAnnullamentoPraticaOnFtp,
      getLogsFileElaborazioneAskFileAnnullamentoPratiche,
      logMessages,
      uploadedFiles,
      loading,
      moment,
      fetchUploadedFiles,
      currentPage,
      filesPerPage,
      paginatedFiles,
      searchQuery,
      filteredFiles,
      removeFile,
      handleFileDownload
    }

  },
}
</script>
<style>
:root {
  --primary-color: #3B82F6;
  --success-color: #4CAF50;
  --border-color: #e2e8f0;
  --text-primary: #0f172a;
  --text-secondary: #475569;
  --bg-gradient: linear-gradient(0deg, #04ba2e 70%, #cad806 100%);
  --card-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1);
}

/* Layout and Container styles */
.center-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 2000px;
  margin: 0 auto;
  padding: 2rem;
}

/* Card and Header styles */
.upload-card {
  width: 100%;
  background: white;
  border-radius: 12px;
  box-shadow: var(--card-shadow);
  transition: transform 0.2s, box-shadow 0.2s;
}

.upload-content {
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  align-items: center;
}

.upload-zone {
  width: 100%;
  max-width: 800px;
  border: 2px dashed var(--border-color);
  border-radius: 8px;
  padding: 2rem;
  text-align: center;
  transition: all 0.2s;
  margin: 0 auto;
}

.button-wrapper {
  position: relative;
  width: 150px;
  text-align: center;
  margin: 0 auto;
}

.button-wrapper span.label {
  position: relative;
  z-index: 0;
  display: inline-block;
  width: 100%;
  background: #e5e5e5 !important;
  cursor: pointer;
  padding: 10px 0;
  text-transform: uppercase;
  font-size: 12px;
  border-radius: 3px;
  box-shadow: 0 10px 13px -7px #00000050;
  color: var(--text-secondary);
}

#upload {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

/* Action buttons */
.action-buttons {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}

.upload-button {
  padding: 0.75rem 1.5rem !important;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  background: #1f5d38 !important;
  color: white !important;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

/* History card */
.history-card {
  width: 100%;
  margin-top: 2rem;
  background: white;
  border-radius: 12px;
  box-shadow: var(--card-shadow);
}

.page-title {
  font-size: 20px;
  text-align: center;
  color: var(--text-primary);
  margin: 1rem 0;
}

.file-table {
  width: 100%;
  border-collapse: collapse;
}

.file-table th,
.file-table td {
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid var(--border-color);
}

.file-table th {
  background: var(--bg-gradient);
  font-weight: bold;
  color: white !important;
}

.p-datatable .p-column-header-content {
  font-weight: 600;
  color: #fff !important;

}

/* Utility classes */
.file-search-input {
  width: 200px;
  margin-bottom: 1rem;
  padding: 8px;
  border: 1px solid var(--border-color);
  border-radius: 5px;
  transition: border-color 0.2s;
}

.file-search-input:focus {
  outline: none;
  border-color: var(--primary-color);
}

.file-count-select-wrapper {
  margin: 20px auto 0;
  width: fit-content;
}

.file-count-select {
  padding: 0.5rem;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  background: white;
  cursor: pointer;
  transition: border-color 0.2s;
}

.file-count-select:hover {
  border-color: var(--primary-color);
}

.p-error {
  color: #dc2626;
  margin-top: 0.5rem;
  font-size: 0.875rem;
}

.file-preview-container {
  width: 100%;
  max-width: 800px;
  margin-top: 1.5rem;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 8px;
}

.file-preview-container h3 {
  font-size: 1rem;
  color: var(--text-primary);
  margin-bottom: 1rem;
  text-align: left;
}

.file-preview-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.file-preview-item {
  display: flex;
  align-items: center;
  padding: 0.5rem;
  background: white;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  margin-bottom: 0.5rem;
}

.file-icon {
  color: var(--text-secondary);
  margin-right: 0.5rem;
}

.file-name {
  flex: 1;
  font-size: 0.875rem;
  color: var(--text-secondary);
  text-align: left;
}

.remove-button {
  background: none;
  border: none;
  color: #dc3545;
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.remove-button:hover {
  background-color: #fff5f5;
}

.remove-button i {
  font-size: 1rem;
}

.download-button {
  background-color: transparent;
  margin-left: 15px;
  border: none;
  color: var(--primary-color);
  cursor: pointer;
}

.download-button:hover {
  color: #0056b3;
}
</style>
